
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import {loadPaginatedECSales}  from "@/api/onlineshop";
// import BalanceDetails from "@/components/cards/BalanceDetails.vue";
// import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue";
// import ECShopAdvisory from  "@/views/ECShopAdvisory.vue";

export default defineComponent({
  name: "retailsales",
  components: {
    // BalanceDetails,
    // CompanyPolicy,
    // ECShopAdvisory
  },
  data() { 
    return { 
      list : [],
      loading: true,
    }
  },
  mounted(){
      this.loadPaginatedECSales();
  },
  methods : {
    async loadPaginatedECSales(){ 
      this.loading = true;
      const response = await loadPaginatedECSales(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("onlineShopTab") || "0");
      setCurrentPageTitle("Online Shop");

    });
    
  }
});
